import WebHeader from "@components/store/navigation/multi-level-header/web";
import ResponsiveHeader from "@components/store/navigation/multi-level-header/responsive";

import withResponsiveToggle from "@stadium/ui/src/hoc/responsive-toggle";

const MultiLevelHeader = withResponsiveToggle({
  WebView: WebHeader,
  ResponsiveView: ResponsiveHeader,
});

export default MultiLevelHeader;
